var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "content-header row" }, [
      _c("div", { staticClass: "content-header-left col-md-8 col-12 mb-2" }, [
        _c("div", { staticClass: "row breadcrumbs-top" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h2", { staticClass: "content-header-title float-left mb-0" }, [
              _vm._v("Upload Nominal Roll\n                    ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "breadcrumb-wrapper col-12" }, [
              _c("ol", { staticClass: "breadcrumb" }, [
                _c(
                  "li",
                  { staticClass: "breadcrumb-item" },
                  [
                    _c("router-link", { attrs: { to: "/home" } }, [
                      _vm._v(
                        "\n                                    " +
                          _vm._s(_vm.trans("general.home")) +
                          "\n                                "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "breadcrumb-item" },
                  [
                    _c("router-link", { attrs: { to: "/paye/staff" } }, [
                      _vm._v(
                        "\n                                    " +
                          _vm._s(_vm.trans("staff.staff")) +
                          "\n                                "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", { staticClass: "breadcrumb-item active" }, [
                  _vm._v(
                    "\n                                Upload Nominal Roll\n                            "
                  )
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "content-header-right text-md-right col-md-4 col-12 d-md-block d-none"
        },
        [
          _c("div", { staticClass: "form-group breadcrum-right" }, [
            _c(
              "a",
              {
                staticClass:
                  "btn btn-primary btn-sm waves-effect waves-float waves-light mr-1",
                attrs: { href: "/files/STAFF_SAMPLE.xlsx", download: "" }
              },
              [
                _c("i", { staticClass: "fas fa-download" }),
                _vm._v(" " + _vm._s(_vm.trans("general.download_template")))
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-sm pull-right",
                on: {
                  click: function($event) {
                    return _vm.$router.push("/paye/staff")
                  }
                }
              },
              [
                _c("i", { staticClass: "feather icon-list" }),
                _vm._v(" " + _vm._s(_vm.trans("staff.staff_list")))
              ]
            )
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-body" }, [
      _c("div", { staticClass: "card" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "card-content" }, [
          _c("div", { staticClass: "card-body" }, [
            _c(
              "form",
              {
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.proceed.apply(null, arguments)
                  },
                  keydown: function($event) {
                    return _vm.staffForm.errors.clear($event.target.name)
                  }
                }
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xl-6 col-md-6 col-12" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("file-upload-input", {
                          attrs: {
                            "button-text": _vm.trans("general.excel"),
                            token: _vm.staffForm.upload_token,
                            module: "staff",
                            "clear-file": _vm.clear_message_attachment,
                            "module-id": _vm.staffForm.id
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-8 offset-md-4" },
                    [
                      _c(
                        "button-spinner",
                        {
                          staticClass:
                            "btn btn-primary mr-1 mb-1 waves-effect waves-light pull-right",
                          staticStyle: { height: "39px", color: "#fff" },
                          attrs: {
                            "is-loading": _vm.staffForm.isLoading,
                            disabled: _vm.staffForm.isLoading
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.trans("general.save")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          staticClass:
                            "btn btn-danger waves-effect waves-light pull-right mr-1 mb-1",
                          attrs: { to: "/paye/staff" }
                        },
                        [_vm._v(_vm._s(_vm.trans("general.cancel")))]
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h4", { staticClass: "card-title" }, [_vm._v("Upload Nominal Roll")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }